import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import RankImage from "@/components/RankImages";
import VersatileLink from "@/components/VersatileLink";
import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import Image from "next/legacy/image";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CardArtwork(_ref) {
  let {
    active,
    index,
    focusIndex,
    rank,
    item,
    className,
    href,
    linkAttr = {},
    intersect = true,
    showValuePlanLabel = false
  } = _ref;
  const url = item.thumbnailUrl;
  const progress = parseInt(item.resume_point, 10) / parseInt(item.duration, 10) * 100 || 0;
  const viewProgressBar = useMemo(() => {
    const resumePoint = (item === null || item === void 0 ? void 0 : item.resume_point) || 0;
    const duration = (item === null || item === void 0 ? void 0 : item.duration) || 0;
    return resumePoint > 0 && duration > 0;
  }, [item]);
  const viewRank = useMemo(() => {
    return rank && !(focusIndex === index) && active;
  }, [rank, focusIndex, index, active]);
  const viewInactiveRank = useMemo(() => {
    return rank && !active;
  }, [rank, active]);
  const artwork = /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.artwork, className, {
      [styles.ranking]: rank
    }),
    "aria-label": item.name,
    tabIndex: 0,
    role: "link",
    children: [viewRank && /*#__PURE__*/_jsx("div", {
      className: styles.rankingImage,
      children: /*#__PURE__*/_jsx(RankImage, {
        rank: rank
      })
    }), viewInactiveRank && /*#__PURE__*/_jsx("div", {
      className: styles.rankingImage,
      children: /*#__PURE__*/_jsx(RankImage, {
        rank: rank
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.image,
        children: intersect && !!url && /*#__PURE__*/_jsx(Image, {
          src: url,
          alt: item.name,
          layout: "fill",
          objectFit: "contain"
        })
      }), viewProgressBar && /*#__PURE__*/_jsx("div", {
        className: styles.progress,
        children: /*#__PURE__*/_jsx("span", {
          className: styles["progress-bar"],
          children: /*#__PURE__*/_jsx("span", {
            role: "presentation",
            className: styles["progress-completed"],
            style: {
              width: `${progress}%`
            }
          })
        })
      }), showValuePlanLabel && /*#__PURE__*/_jsx("div", {
        className: styles.valueplanLabel,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/images/valueplan_label.png",
          alt: "valueplan_label",
          layout: "fill",
          objectFit: "cover"
        })
      })]
    })]
  });
  if (href) {
    return /*#__PURE__*/_jsx(VersatileLink, {
      href: href,
      children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, linkAttr), {}, {
        children: artwork
      }))
    });
  } else {
    return artwork;
  }
}